import React from "react"
import styled from "styled-components"
import {headingFont, TitleColor} from "../../utils/vars";

const Text = styled.span`
  font-family: ${headingFont};
  font-size: ${p => p.small ? "32px" : "48px"};
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.015em;
  color: ${p => p.color ? p.color : TitleColor};
  ${p => p.styling};
`

const TitlePrimary = ({ children, color, small = false, slim = false, styling, twoLine = false, text }) => {
  return(
    <>
      {
        twoLine ?
          <>
            <Text
              small={small}
              slim={slim}
              styling={styling}
              color={color}
            >
              {text["line1"]}
            </Text>
            <br/>
            <Text
              small={small}
              slim={slim}
              styling={styling}
              color={color}
            >
              {text["line2"]}
            </Text>
          </>
          :
          <Text
            small={small}
            slim={slim}
            styling={styling}
            color={color}
          >
            {children}
          </Text>
      }
    </>

  )
}

export default TitlePrimary